module.exports = __webpack_public_path__ + "img/lv21.9a766af8.png";